// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogCard_wrapper__VBzUD","info":"BlogCard_info__E5GWt","description":"BlogCard_description__taDLb","imageWrapper":"BlogCard_imageWrapper__xGJaD"};